import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { fetchApi } from "../../utlis/axios";

const PAGE_LIMIT = 100;
const MAX_PAGES = 50;

export const formatPkr = (value) =>
  `Rs. ${new Intl.NumberFormat("en-PK").format(Number(value) || 0)}`;

export const formatDate = (iso) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
};

/**
 * All receipts this user may see, newest first. Pharmacy users only get their
 * own store's receipts. Reports total across every receipt, so all pages load.
 */
export function useReceipts() {
  const userInfo = useSelector((s) => s.authSlice.userInfo);
  const access = userInfo?.access;
  const user = userInfo?.user;
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const headers = { Authorization: `Bearer ${access}` };
    const role = (user?.role || "").toLowerCase();
    const storeOnly = (role === "pharmacist" || role === "medicalstaff") && !user?.is_superuser;

    (async () => {
      try {
        let filter = "";
        if (storeOnly) {
          const stores = await fetchApi.get(`medical-store/?user=${user?.id}`, { headers });
          const store = stores?.data?.results?.[0];
          if (!store) {
            if (!cancelled) setLoading(false);
            return;
          }
          filter = `&medical_store=${store.id}`;
        }
        const all = [];
        let url = `medical-store-receipt/?limit=${PAGE_LIMIT}&is_active=true${filter}`;
        for (let page = 0; url && page < MAX_PAGES; page += 1) {
          const r = await fetchApi.get(url, { headers });
          all.push(...(r?.data?.results || []));
          url = r?.data?.next || null;
        }
        all.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        if (!cancelled) setReceipts(all);
      } catch (e) {
        console.error("[receipts]", e);
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [access, user?.id, user?.role, user?.is_superuser]);

  return { receipts, loading, error };
}
